import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Chip,
} from '@mui/material';
import PersonalInjuryIcon from '@mui/icons-material/PersonalInjury';
export interface SelectablePermanentInjury {
  id: string;
  name: string;
  description: string;
  effectLabel?: string;
}

interface Props {
  open: boolean;
  memberName: string;
  injuries: SelectablePermanentInjury[];
  onClose: () => void;
  onSelect: (injury: SelectablePermanentInjury) => void;
}

export const SelectPermanentInjuryModal: React.FC<Props> = ({ open, memberName, injuries, onClose, onSelect }) => {
  const [selected, setSelected] = React.useState<SelectablePermanentInjury | null>(null);

  React.useEffect(() => {
    if (!open) setSelected(null);
  }, [open]);

  const handleConfirm = () => {
    if (selected) {
      onSelect(selected);
      setSelected(null);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PersonalInjuryIcon />
        Permanent Injury — {memberName}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Select the injury suffered by this spellcaster.
        </Typography>
        <List disablePadding>
          {injuries.map((injury) => (
            <ListItemButton
              key={injury.id}
              selected={selected?.id === injury.id}
              onClick={() => setSelected(injury)}
              sx={{ borderRadius: 1, mb: 0.5 }}
            >
              <ListItemText
                primary={
                  <Typography variant="body1" fontWeight={selected?.id === injury.id ? 600 : 400}>
                      {injury.name}
                  </Typography>
                }
                secondary={
                  <>
                    <Chip
                      label={injury.effectLabel ?? 'No stat effect'}
                      size="small"
                      color={injury.effectLabel ? 'error' : 'default'}
                      sx={{ mr: 1, mb: 0.5 }}
                    />
                    <Typography variant="caption" color="text.secondary" component="span">
                      {injury.description}
                    </Typography>
                  </>
                }
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          disabled={!selected}
          onClick={handleConfirm}
          startIcon={<PersonalInjuryIcon />}
        >
          Apply Injury
        </Button>
      </DialogActions>
    </Dialog>
  );
};
